// extracted by mini-css-extract-plugin
export var chip = "_f4-0";
export var filterDropdown = "_f4-5";
export var filterItem = "_f4-6";
export var icon = "_f4-1";
export var removeButton = "_f4-3";
export var removeIcon = "_f4-4";
export var separator = "_f4-2";